module.exports = __webpack_public_path__ + "img/OSL_CKFoodTruck029.a73c5798.jpg";